import React, { useEffect, useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./App/style.css";
import useIMSReady from "../Hooks/useIMSReady";
import DxpPageShell from "./Common/StandaloneFormViews/DxpPageShell";
import { getDXPRegistrationLink } from "../Helpers/utils";
import useBackButtonOverride from "../Hooks/useBackButtonOverride";

function PartnerPortalLandingPage(props: any) {
  useBackButtonOverride(getDXPRegistrationLink());

  const redirectPath = localStorage.getItem("RedirectPath");
  const navigate = useNavigate();
  const [isIMSReady] = useIMSReady();
  const [userState, setUserState] = useState<any>();
  const { children } = props;

  const redirectIMSLoginPage = () => {
    window.adobeIMS?.signIn();
  };

  const getPath = () => {
    if (children) {
      localStorage.removeItem("RedirectPath");
      localStorage.setItem("IsManageProfilePage", "true");
    } else if (redirectPath) {
      localStorage.removeItem("IsManageProfilePage");
    }
  };
  getPath();

  useEffect(() => {
    if (isIMSReady) {
      const ims = window.adobeIMS;
      if (ims?.isSignedInUser?.()) {
        const tokenPromise = ims.validateToken?.();
        if (tokenPromise) {
          tokenPromise
            .then((res: unknown) => {
              setUserState(res ? "loggedIn" : "notLoggedIn");
            })
            .catch(() => {
              setUserState("notLoggedIn");
            });
        } else {
          setUserState("notLoggedIn");
        }
      } else {
        redirectIMSLoginPage();
      }
    }
  }, [isIMSReady]);

  useLayoutEffect(() => {
    if (userState === "loggedIn") {
      window?.adobeIMS?.getProfile?.();
    }
  }, [userState]);

  useLayoutEffect(() => {
    if (userState !== "loggedIn" || children) {
      return;
    }
    const manage = localStorage.getItem("IsManageProfilePage");
    const redirect = localStorage.getItem("RedirectPath");
    if (manage === "true") {
      navigate("/manageprofile");
    }
    if (redirect) {
      navigate(redirect);
    }
  }, [userState, children, navigate]);

  useLayoutEffect(() => {
    if (userState === "notLoggedIn") {
      redirectIMSLoginPage();
    }
  }, [userState]);

  if (userState === "loggedIn" && children) {
    return children;
  }

  return (
    <>
      <DxpPageShell
        requireCommonHeaders
        containerClassName="dxp-template-root--landing-scrim"
      >
        <div className="dxp-partner-landing-spacer" />
      </DxpPageShell>
      <div className="fullScreen" />
    </>
  );
}

export default PartnerPortalLandingPage;
